/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 用户的host_id
   */
  host_id?: string;
}
export interface ActivitiesAuthRoleAuthRes {
  code: number;
  msg: string;
  data: Data;
}
export interface Data {
  /**
   * （废弃字段）企业版：1 管理员权限，2:普通员工；个人版：1 创建者，2 管理者。
   */
  role_id: number;
  /**
   * （废弃字段）1：企业版本，2 个人版本
   */
  version: number;
  /**
   * 0 非成员，1创建者，2管理员，4普通成员
   */
  org_role_id: number;
  /**
   * 主办方创建者所属企业的会议版本，1：企业版本，2 个人版本
   */
  host_corp_version: number;
  /**
   * 2 企业版 11 商业版/团队版 15 免费企业(个人版200000001也是免费版) 16 教育版
   */
  host_corp_tag_type: number;
  /**
   * 登录态用户在主办方创建者所属企业下的角色。1 企业超管，2 其他角色
   */
  host_corp_role_id: string;
  /**
   * 主办方创建者所属企业ID（仅用于显示，不能用于鉴权）(废弃)
   */
  host_corp_id: string;
  /**
   * 主办方创建者所属企业名称
   */
  host_corp_name: string;
  /**
   * 主办方名字
   */
  host_name: string;
  /**
   * 已发货订单数量
   */
  delivered_order_num: number;
  /**
   * 主办方创建者所属企业ID（仅用于显示，不能用于鉴权）
   */
  host_account_corp_id: string;
}

const ActivitiesAuthRoleAuth = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<ActivitiesAuthRoleAuthRes>(
    '/wemeet-tapi',
    '/v2/activities/auth/role-auth',
    data,
    ctx,
  );

  return res;
};

export default ActivitiesAuthRoleAuth;
